import {
  customShadowlessElement,
  type CorrectComponentType,
  correctElementType,
  toHyphenated,
} from "@brytdesigns/web-component-core/utils";
import { onMount, onCleanup } from "solid-js";

type Props = {
  dataState: "initial" | "copied";
};

const Component: CorrectComponentType<Props> = (_, { element }) => {
  if (!element.querySelector("a")) {
    return console.error("The component must have a <a> tag");
  }
  const controller = new AbortController();

  onMount(() => {
    const anchor = element.querySelector<HTMLAnchorElement>("a");
    anchor?.setAttribute("rel", "noopener noreferrer");
    anchor?.setAttribute("target", "_blank");
  });

  element.addEventListener(
    "click",
    async (event) => {
      event.preventDefault();
      const anchor = element.querySelector<HTMLAnchorElement>("a");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href) return;
      element.setAttribute(toHyphenated("dataState"), "copied");
      await navigator.clipboard.writeText(href);
      setTimeout(() => {
        element.setAttribute(toHyphenated("dataState"), "initial");
      }, 1000);
    },
    {
      signal: controller.signal,
    },
  );

  onCleanup(() => {
    controller.abort();
  });
};

customShadowlessElement("copy-link-action", {}, correctElementType(Component));
